import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from '../../../../../../core/Services/local-storage.service';
import { DatePipe } from '@angular/common';
import { AuthService } from '../../../../../../core/modules/auth/services/auth.service';
import { LicensingBaseDialogComponent, ToolOptions } from '../base/licensing-base-dialog.component';
import { DialogData, License, LicenseState } from '../../../../services/licensing.interfaces';
import { LicensingRenewalDialogComponent } from '../../licensing-renewal-dialog.component';
import { CustomAnalyticEventsService } from '../../../../../../core/Services/customAnalyticEvents.service';
import { EntitlementLicensingService } from '../../../../services/entitlement-licensing.service';

@Component({
  selector: 'app-licensing-paid-dialog',
  templateUrl: './licensing-paid-dialog.component.html',
  styleUrls: [ '../base/licensing-base-dialog.component.scss' ]
})
export class LicensingPaidDialogComponent extends LicensingBaseDialogComponent implements OnInit, OnDestroy {


  constructor( public _firebaseAnalytics: CustomAnalyticEventsService,
    public _authSvc: AuthService,
    public licensingService: EntitlementLicensingService,
    public localStorageService: LocalStorageService,
    public _datePipe: DatePipe)  {
    super(_firebaseAnalytics,  _authSvc, licensingService, localStorageService,  _datePipe);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.checkMuteStatus();
    this.buildTemplateData(this.data.licenseState);
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public forceRecheckLicense(): void {
    this.recheckLicense()
  }

  private buildTemplateData(licenseState: LicenseState): void {

    const expiryMessage: string = this.updateExpiryMessage(licenseState);

    const alertLevel: number = this.getAlertLevel(licenseState);
    const showDataDeletionMessage: boolean = (licenseState.expiresIn < 0);
    const showFooterLeft: boolean = ((licenseState.expiresIn > 7 && licenseState.expiresIn <= 30) || showDataDeletionMessage);
    const showSupportButton: boolean = false; // (licenseState.expiresIn <= 14);
    const showRenewButton: boolean = (licenseState.expiresIn <= 30);
    const displayInfoBlock: boolean = (licenseState.expiresIn <= 30);


    const tool: ToolOptions = this.getTool(licenseState.primarySubscription);
    this.dialogData = {
      domain : licenseState.license.domain,
      expireDays : licenseState.expiresIn,
      expireDate : this.getExpiryDate(licenseState),
      displayDate: true,
      expiryMessage,
      alertLevel,
      showIcon: (alertLevel > 0),
      controls: {
        showSupportButton,
        showRenewButton,
        showReminderCheckbox: (licenseState.expiresIn <= 30 && licenseState.expiresIn > 7),
        showRecheckLicenseButton: false,
        showLogout: false
      },
      displayInfoBlock,
      showDataDeletionMessage,
      showFooterLeft,
      showUpgrade: tool.name === 'Gopher for Chrome',
      tool
    };
  }
}
